import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import ServiceTypeEditor from "../../editors/catalogue/serviceType";

const ServiceTypes: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.ServiceTypesList}
			endpoint={Endpoint.ServiceTypes}
			addScreen={{ screen: ServiceTypeEditor, isAllowed: hasPermission(Permission.ServiceTypesAdd) }}
			editScreen={{ screen: ServiceTypeEditor, isAllowed: hasPermission(Permission.ServiceTypesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.ServiceTypesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="copyServices" title={t("copyServices")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default ServiceTypes;
